
import './App.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Footer from './components/Footer';
import Prices from './pages/Prices';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Datenschutz from './pages/Datenschutz';
import GoBD from './pages/GoBD';
import Impressum from './pages/Impressum';
import AGB from './pages/AGB';
import ScrollToTop from './components/ScrollToTop';
import { Helmet, HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Payroll Experten - Lohn- und Gehaltsabrechnungen</title>
        <meta
          name="description"
          content="Professionelle Lohn- und Gehaltsabrechnungen für Unternehmen in München und Umgebung."
        />
      </Helmet>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/prices" element={<Prices />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/goBD" element={<GoBD />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/agb" element={<AGB />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
